import { render, staticRenderFns } from "./ReductionDisplay.vue?vue&type=template&id=520051ba&scoped=true&"
import script from "./ReductionDisplay.vue?vue&type=script&lang=js&"
export * from "./ReductionDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520051ba",
  null
  
)

export default component.exports